// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../assets/images/grey-texture.jpg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "._1lVz{width:100%;padding:.8rem 0;background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat 50%;background-size:cover;border-top:1px solid #fcd700;position:fixed;bottom:0;left:0;z-index:1}@media (min-width:62em){._1lVz{padding:1.6rem 0}}._2dc1{display:flex}._2YVi{display:none}@media (min-width:62em){._2YVi{display:flex;align-items:center;flex:1}}._h8T{width:25%;margin:0 1.5rem 0 0;padding:.8rem .6rem;background:#fff;box-shadow:0 .4rem .8rem 0 rgba(0,0,0,.08)}._1Z-t{display:flex;align-items:center}._34Ui{max-width:5rem}.YtiR{flex:1}._2eHz{cursor:pointer}@media (min-width:62em){._2eHz:hover svg{color:#fcd700}}._2FQ_{flex:1}@media (min-width:62em){._2FQ_{width:25%;display:flex;flex:initial}}._25lV{width:100%;margin:0;border:1px solid #fcd700}.LwN0{width:4.8rem;height:4.8rem;margin:0 0 0 .8rem;display:flex;color:#fff;justify-content:center;align-items:center;box-shadow:0 .4rem .8rem 0 rgba(0,0,0,.08)}@media (min-width:62em){.LwN0{display:none}}html[dir=rtl] ._h8T{margin:0 0 0 1.5rem}html[dir=rtl] .LwN0{margin:0 .8rem 0 0}", ""]);
// Exports
exports.locals = {
	"wrapp": "_1lVz",
	"container": "_2dc1",
	"products": "_2YVi",
	"productWrapp": "_h8T",
	"product": "_1Z-t",
	"imgWrapp": "_34Ui",
	"name": "YtiR",
	"addBtnWrapp": "_2eHz",
	"btnWrapp": "_2FQ_",
	"btn": "_25lV",
	"toggler": "LwN0"
};
module.exports = exports;
